<template>
  <div class="page-container referrals-page">
    <portal to="page-name">Solicitantes / Indicações</portal>
    <div class="card card-page">
      <div class="card-header">
        <h1 class="card-title">Solicitantes / Indicações</h1>
      </div>
      <div class="card-body">
        <referral-list />
      </div>
    </div>
  </div>
</template>

<script>
import referralList from './List.vue';

export default {
  components: {
    referralList,
  },
};
</script>

<style lang="scss">
  .referrals-page {
  }
</style>
